/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_AuftraggeberInputs */

const de__field_auftraggeber = /** @type {(inputs: _Field_AuftraggeberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auftraggeber:in`)
};

/**

* @param {_Field_AuftraggeberInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_auftraggeber = /** @type {((inputs?: _Field_AuftraggeberInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_AuftraggeberInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_auftraggeber(inputs)
});